import { render, staticRenderFns } from "./TakipTalebiTaslak.vue?vue&type=template&id=77f16540"
import script from "./TakipTalebiTaslak.vue?vue&type=script&lang=ts"
export * from "./TakipTalebiTaslak.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports